import {Routes} from '@angular/router';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ADMINISTRATION_DATA_PORTAL_ROUTES} from './administration-data-portal/administration-data-portal.routes';

export const DATA_PORTAL_ROUTES: Routes = [
  {
    path: '',
    component: DashboardComponent
  },
  {
    path: 'data-portal-administration',
    children: ADMINISTRATION_DATA_PORTAL_ROUTES
  }
];
